import { MessageDismissalStatus } from './reducer';

export const setMessageDismissalItem = (data: MessageDismissalStatus) => ({
    type: 'SET_ITEM',
    data,
});
